import React from 'react';

import PropTypes from 'prop-types';

import { PhoneNumber } from '../../../components/contact-info/phone-number';
import { cleanLocationString } from '../helpers';

export const PhoneLine = ({ phone }) => {
  const cleanPhone = cleanLocationString(phone);
  if (!cleanPhone) {
    return null;
  }
  return <PhoneNumber phoneNumber={cleanPhone} />;
};

PhoneLine.propTypes = {
  phone: PropTypes.string,
};
